/**
 * Get csrf cookie name
 * */
const getCsrfCookieName = () => {
  if (typeof window === 'undefined') return '';
  // stage.aiplanet.com = aiplanetstagecsrftoken
  // aiplanet.com = aiplanetcsrftoken
  // else = aiplanetlocalcsrftoken
  const host = window.location.host;
  if (host === 'stage.aiplanet.com') {
    return 'aiplanetstagecsrftoken';
  } else if (host === 'aiplanet.com') {
    return 'aiplanetcsrftoken';
  } else {
    return 'aiplanetlocalcsrftoken';
  }
};
export default getCsrfCookieName;
